import {Link} from 'react-router-dom';
import Typed from 'react-typed';
import Particles from "react-tsparticles";
import { Carousel } from 'react-bootstrap';
import projects from '../utilities/project-data';
import React from "react";
import * as SimpleIcons from "react-icons/si";

// image imports
import techStackMobile from '../website-images/home-page/tech-stack-mobile.png';
import techStackDesktop from '../website-images/home-page/tech-stack-desktop.png';

function Home() {
    return (
        <section className="home-page">
            <section className="banner-section">
                {/* Adding particle effect to the banner */}
                <Particles 
                className="particles-area"
                    options={{
                        fpsLimit: 30,
                        interactivity: {
                            events: {
                            onHover: {
                                enable: true,
                                mode: "repulse",
                            },
                            resize: true,
                            },
                            modes: {
                            bubble: {
                                distance: 400,
                                duration: 2,
                                opacity: 0.8,
                                size: 40,
                            },
                            repulse: {
                                distance: 100,
                                duration: 0.5,
                            },
                            },
                        },
                        particles: {
                            color: {
                            value: "#66FCF1", // color of dots
                            },
                            links: {
                            color: "#ffffff", // color of lines
                            distance: 150,
                            enable: true,
                            opacity: 0.5,
                            width: 2,
                            },
                            collisions: {
                            enable: true,
                            },
                            move: {
                            direction: "none",
                            enable: true,
                            outMode: "bounce",
                            random: false,
                            speed: 2, // change particle speed movement here
                            straight: false,
                            },
                            number: {
                            density: {
                                enable: true,
                                value_area: 900,
                            },
                            value: 30, // decreate particles amount here
                            },
                            opacity: {
                            value: 0.7,
                            },
                            shape: {
                            type: "circle",
                            },
                            size: {
                            random: true,
                            value: 4,
                            },
                        },
                        detectRetina: true,
                        }}
                />
                <div className="hero-text">
                    <h2 className="intro-text">Welcome to my Portfolio Website!</h2>
                    {/* Inserting text that will have a typed effect */}
                        <Typed 
                        className="typed-text"
                        strings={["Hi There!", "I create Websites", "I am a Web Developer", "I am a Web Designer", "And a whole lot more...", "I am Patrick Neil"]}
                        typeSpeed={60}
                        backSpeed={80}
                    />
                    <Link className="project-link grow" to="/projects">View Projects</Link>
                </div>

            </section>
            <section className="about-my-skills">
                {/* use the more rectangular image on wider viewports */}
                <div className="section-content">
                    <img className="home-skills-picture"
                        srcSet={`${techStackMobile} 300w, 
                                ${techStackDesktop} 800w`} 
                        sizes="(max-width: 800px) 300px, 800px"
                        alt="Teck Stack description"/>
                    <div className="about-my-skills-text">
                        <h2>Skills I Offer</h2>
                        <p>
                            The skills I bring into a web development position pertain to both development and design, I am well versed in building responsive websites. This said know how to make websites with Semantic HTML and well structured CSS and SASS. Using JavaScript I am able to make functional websites for my clients. I also have working knowledge of the following JavaScript related libraries: jQuery, Bootstrap and React, I have projects that show my skill in these areas. Not only that but my work in PHP has given me some knowledge on backend web development as well. I am also a team player, I know how to coordinate a team and work on projects with others using GitHub. Also, guess what, this website you're viewing right now was designed by me in Adobe XD, I also have working knowledge of other Adobe products such as photoshop and Illustrator.
                        </p>
                    </div>
                </div>
            </section>

            <section className="prominent-work-section">
                {/* Change the numbers within the array indexes to show different prominent works */}
                <div className="section-content">
                    <h2>Prominent Work</h2>
                    <Carousel>
                        <Carousel.Item interval={1000000}>
                            <div className="slide-content even-slide">
                                <img
                                className="d-block w-100" src={`${projects[4].image}`}
                                alt="First slide"
                                />
                                <div className="slide-project-data">
                                    <div className="title-and-link-container">
                                        <h3>{projects[4].title}</h3>
                                        <a className="single-project-link grow" href={projects[4].external_link}>See Website</a>
                                    </div>
                                    <div className="tech-stack">
                                        <h3>Tech Stack:</h3> {projects[4].techStack.map((item, i) => React.createElement(SimpleIcons[`${item}`]))}
                                    </div>
                                    <p className="project-description">{projects[4].long_description}</p>
                                </div>
                            </div>
                            {/* <Carousel.Caption>
                            <h3>First slide label</h3>
                            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                            </Carousel.Caption> */}
                        </Carousel.Item>
                        <Carousel.Item interval={1000000}>
                            <div className="slide-content odd-slide">
                                    <img
                                    className="d-block w-100" src={`${projects[8].image}`}
                                    alt="First slide"
                                    />
                                    <div className="slide-project-data">
                                        <div className="title-and-link-container">
                                            <h3>{projects[8].title}</h3>
                                            <a className="single-project-link grow" href={projects[8].external_link}>See Website</a>
                                        </div>
                                        <div className="tech-stack">
                                            <h3>Tech Stack:</h3> {projects[8].techStack.map((item, i) => React.createElement(SimpleIcons[`${item}`]))}
                                        </div>
                                        <p className="project-description">{projects[8].long_description}</p>
                                    </div>
                                </div>
                                {/* <Carousel.Caption>
                                <h3>First slide label</h3>
                                <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                                </Carousel.Caption> */}
                        </Carousel.Item>
                        <Carousel.Item interval={1000000}>
                        <div className="slide-content even-slide">
                                <img
                                className="d-block w-100" src={`${projects[7].image}`}
                                alt="First slide"
                                />
                                <div className="slide-project-data">
                                    <div className="title-and-link-container">
                                        <h3>{projects[7].title}</h3>
                                        <a className="single-project-link grow" href={projects[7].external_link}>See Website</a>
                                    </div>
                                    <div className="tech-stack">
                                        <h3>Tech Stack:</h3> {projects[7].techStack.map((item, i) => React.createElement(SimpleIcons[`${item}`]))}
                                    </div>
                                    <p class="project-description">{projects[7].long_description}</p>
                                </div>
                            </div>
                            {/* <Carousel.Caption>
                            <h3>First slide label</h3>
                            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                            </Carousel.Caption> */}
                        </Carousel.Item>
                    </Carousel>
                </div>
            </section>
        </section>
    )
}

export default Home;
